'use client';

import React, { createContext, useContext, useState, ReactNode, useRef } from 'react';

interface LoginPopupData {
	title?: string;
	subtitle?: string;
	linkLabel?: string;
	linkUrl?: string;
}

interface WhatsappData {
	chatNumber?: string;
}

type ModalContextType = {
    isOpen: boolean;
    content: ReactNode;
    openModal: (content: ReactNode) => void;
    closeModal: () => void;
	loginPopupData: LoginPopupData | null;
	whatsappData: WhatsappData | null;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children, loginPopupData, whatsappData }: { children: ReactNode, loginPopupData: LoginPopupData | null, whatsappData: WhatsappData | null }) => {
    const overlay = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState<ReactNode>(null);

    const openModal = (modalContent: ReactNode) => {
        setContent(modalContent);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setContent(null);
    };

    const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === overlay.current) {
            closeModal();
        }
    }

    return (
        <ModalContext.Provider value={{ isOpen, content, openModal, closeModal, loginPopupData, whatsappData }}>
            {children}
            {isOpen && (
                <div ref={overlay} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={(e) => handleClose(e)}>
                    <div className="bg-white relative w-full max-w-[560px] py-14 px-4 sm:px-16 rounded-none md:rounded-[30px] shadow-lg flex flex-col items-center">
                        {/* <button className="absolute top-2 right-2" onClick={closeModal}>X</button> */}
                        {content}
                    </div>
                </div>
            )}
        </ModalContext.Provider>
    );
}; 

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
